import { render, staticRenderFns } from "./GraphicCard.vue?vue&type=template&id=37cbcb36&scoped=true&"
import script from "./GraphicCard.vue?vue&type=script&lang=js&"
export * from "./GraphicCard.vue?vue&type=script&lang=js&"
import style0 from "./GraphicCard.vue?vue&type=style&index=0&id=37cbcb36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cbcb36",
  null
  
)

export default component.exports